import { object, string } from 'zod/mini';

export const LOCAL_RELEASE_ID = 'local';

const RELEASE_MANIFEST_PATH = '/release.json';

const RELEASE_MANIFEST_SCHEMA = object({
	releaseId: string(),
});

export async function fetchDeployedReleaseIdOrThrow(): Promise<string> {
	const response = await fetch(RELEASE_MANIFEST_PATH, { cache: 'no-store' });

	if (!response.ok) {
		throw new Error(`Fetching ${RELEASE_MANIFEST_PATH} failed with status ${response.status}`);
	}

	const { releaseId } = RELEASE_MANIFEST_SCHEMA.parse(await response.json());

	return releaseId;
}
